import e from "../../../utilities/tw.js";
const l = {
  bannerContainer: e`relative mx-auto overflow-hidden px-16 py-10 font-sans text-neutral before:absolute sm:w-full sm:py-28`,
  bgImageStyle: e`absolute inset-0 size-full object-cover`,
  contentContainer: e`items-left overflow-wrap relative flex w-full flex-col justify-between gap-2 text-wrap text-left text-neutral sm:gap-2.5`,
  welcomeText: e`text-overline font-bold uppercase`,
  balanceText: e`w-full animate-slideIn text-title-3`,
  balanceValue: e`mx-2 border-b-2 border-b-accent font-bold text-secondary`
};
export {
  l as bannerStyles
};
